import { Component, OnInit, viewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { finalize, takeUntil } from 'rxjs/operators';

import { FileUploaderComponent } from '@pishgamrayan/ng-form-kit';
import {
  CustomResult,
  CustomResultOfGatewayTransporterDescriptor,
  GetBankOnlineGatewaysForIncreaseCreditDto,
} from 'src/app/core/api/models';
import { EventTypes } from 'src/app/core/constants/event-types';
import { RegularExpressions } from 'src/app/core/constants/regular-expressions';
import { DateTimeService } from 'src/app/core/services/date-time.service';
import { GatewayTransporterDescriptorService } from 'src/app/core/services/gateway-transporter-descriptor.service';
import { UtilService } from 'src/app/core/services/util.service';
import { TabsDynamicComponent } from 'src/app/layout/components/tabs-dynamic/tabs-dynamic.component';
import { CreatePaymentCommand } from '../../../core/api/models/create-payment-command';
import { TypeBanks } from '../../../core/api/models/type-banks';
import { TypePayments } from '../../../core/api/models/type-payments';
import { PaymentsService } from '../../../core/api/services';
import { DynamicTabService } from '../../../core/services/dynamic-tab.service';
import { BaseFormPageComponent } from '../../shared/base/components/base-form-page.component';

@Component({
  selector: 'app-new-payment',
  templateUrl: './new-payment.component.html',
  styleUrls: ['./new-payment.component.scss'],
  standalone: false,
})
export class NewPaymentComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region properties
  readonly fileUploader = viewChild<FileUploaderComponent>('fileUploader');

  model: CreatePaymentCommand = {};
  imageUrl: any;
  pdfUrl: any;
  chequeAccountNumber;
  paymentDate: string;
  dueDate: string;

  get TypePayments() {
    return TypePayments;
  }
  get TypeBanks() {
    return TypeBanks;
  }

  amountLetters: string = this.translateService.instant('common.zero');

  isVisibleInvoice: boolean = false;
  isVisibleHelpPage: boolean = false;
  isShowPaymentGatewaySelector: boolean = true;

  paymentTime;
  selectedBankOnlineGateway: GetBankOnlineGatewaysForIncreaseCreditDto;
  bankOnlineGatewayCount: number = 0;

  //#endregion

  constructor(
    protected currentService: PaymentsService,
    public dynamicTabService: DynamicTabService,
    private tabsDynamicComponent: TabsDynamicComponent,
    protected translateService: TranslateService,
    private gatewayTransporterDescriptorService: GatewayTransporterDescriptorService
  ) {
    super();
    this.baseCreateGetApiForSend(this.currentService, 'paymentsCreateGet');
  }

  ngOnInit() {
    try {
      super.ngOnInit();
      this.onCheckAccessApi();
      this.pageVocabs = 'pages.newPayment.';
      this.fields = 'pages.newPayment.fields.';
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.financial);
    }
  }

  //#region init methods

  initModel(): void {
    try {
      this.model = {};
      this.model.isOnlineGeneral = false;
      this.model.typePayment = TypePayments.OnLine;
      this.model.imageName = null;
      this.model.chequeImageAddress = null;
      this.imageUrl = null;
      this.pdfUrl = null;
      this.paymentTime = DateTimeService.getTime();
      super.initModel();
      this.paymentDate = DateTimeService.getCurrentDateTime();
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.financial);
    }
  }

  initForm() {
    this.form = new FormGroup({
      typePayment: new FormControl(''),
      accountInformationId: new FormControl(''),
      typeBank: new FormControl(''),
      amount: new FormControl('', Validators.required),
      description: new FormControl(''),
      billNumber: new FormControl(''),
      paymentDate: new FormControl(''),
      paymentTime: new FormControl(''),
      // cheque
      branchCode: new FormControl(''),
      chequeAccountNumber: new FormControl(''),
      chequeAmount: new FormControl(''),
      chequeImageAddress: new FormControl(''),
      dueDate: new FormControl(''),
      holderName: new FormControl(''),
      nationalCode: new FormControl(''),
      sayadNumber: new FormControl(''),
      serialNumber: new FormControl(''),
      seriesNumber: new FormControl(''),
    });
  }

  //#endregion

  //#region form validations

  setRequiredValidators(fieldName) {
    try {
      this.form.get(fieldName).setValidators(Validators.required);
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.financial);
    }
  }

  clearValidationsForm() {
    try {
      this.form.get('accountInformationId').clearValidators();
      this.form.get('typeBank').clearValidators();
      this.form.get('description').clearValidators();
      this.form.get('billNumber').clearValidators();
      this.form.get('paymentDate').clearValidators();
      this.form.get('paymentTime').clearValidators();
      this.form.get('branchCode').clearValidators();
      this.form.get('chequeAccountNumber').clearValidators();
      this.form.get('chequeAmount').clearValidators();
      this.form.get('chequeImageAddress').clearValidators();
      this.form.get('dueDate').clearValidators();
      this.form.get('holderName').clearValidators();
      this.form.get('nationalCode').clearValidators();
      this.form.get('sayadNumber').clearValidators();
      this.form.get('serialNumber').clearValidators();
      this.form.get('seriesNumber').clearValidators();
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.financial);
    }
  }

  updateValidationsForm() {
    try {
      this.form.get('accountInformationId').updateValueAndValidity();
      this.form.get('typeBank').updateValueAndValidity();
      this.form.get('description').updateValueAndValidity();
      this.form.get('billNumber').updateValueAndValidity();
      this.form.get('paymentDate').updateValueAndValidity();
      this.form.get('paymentTime').updateValueAndValidity();
      this.form.get('branchCode').updateValueAndValidity();
      this.form.get('chequeAccountNumber').updateValueAndValidity();
      this.form.get('chequeAmount').updateValueAndValidity();
      this.form.get('chequeImageAddress').updateValueAndValidity();
      this.form.get('dueDate').updateValueAndValidity();
      this.form.get('holderName').updateValueAndValidity();
      this.form.get('nationalCode').updateValueAndValidity();
      this.form.get('sayadNumber').updateValueAndValidity();
      this.form.get('serialNumber').updateValueAndValidity();
      this.form.get('seriesNumber').updateValueAndValidity();
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.financial);
    }
  }

  changeValidationsForm(type: TypePayments) {
    try {
      this.clearValidationsForm();

      switch (type) {
        case TypePayments.OnLine:
          this.onlinePaymentValidationsForm();
          break;

        case TypePayments.Cheque:
          this.chequePaymentValidationsForm();
          break;

        case TypePayments.DepositToTheAccount:
          this.accountPaymentValidationsForm();
          break;

        case TypePayments.Card:
          this.cardPaymentValidationsForm();
          break;

        case TypePayments.Cash:
          this.cashPaymentValidationsForm();
          break;

        default:
          break;
      }

      this.updateValidationsForm();
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.financial);
    }
  }

  onlinePaymentValidationsForm() {
    try {
      this.setRequiredValidators('amount');
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.financial);
    }
  }

  chequePaymentValidationsForm() {
    try {
      this.setRequiredValidators('accountInformationId');
      this.setRequiredValidators('typeBank');
      this.setRequiredValidators('billNumber');
      this.setRequiredValidators('paymentDate');
      this.setRequiredValidators('paymentTime');
      this.setRequiredValidators('branchCode');
      this.setRequiredValidators('chequeImageAddress');
      this.setRequiredValidators('dueDate');
      this.setRequiredValidators('holderName');

      this.form
        .get('serialNumber')
        .setValidators([Validators.required, Validators.maxLength(10)]);
      this.form
        .get('seriesNumber')
        .setValidators([Validators.required, Validators.maxLength(6)]);
      this.form
        .get('chequeAccountNumber')
        .setValidators([
          Validators.required,
          Validators.minLength(24),
          Validators.maxLength(24),
        ]);
      this.form
        .get('nationalCode')
        .setValidators([
          Validators.required,
          Validators.maxLength(11),
          Validators.minLength(10),
          Validators.pattern(RegularExpressions.justNumber),
        ]);

      this.form
        .get('sayadNumber')
        .setValidators([Validators.required, Validators.maxLength(20)]);

      this.form
        .get('branchCode')
        .setValidators([Validators.required, Validators.maxLength(16)]);

      this.form
        .get('chequeAmount')
        .setValidators([Validators.required, Validators.min(1)]);
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.financial);
    }
  }

  cashPaymentValidationsForm() {
    try {
      //this.setRequiredValidators('accountInformationId');
      //  this.setRequiredValidators('typeBank');
      this.setRequiredValidators('billNumber');
      this.setRequiredValidators('paymentDate');
      this.setRequiredValidators('paymentTime');
      this.setRequiredValidators('amount');
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.financial);
    }
  }

  accountPaymentValidationsForm() {
    try {
      this.setRequiredValidators('amount');
      this.setRequiredValidators('accountInformationId');
      // this.setRequiredValidators('typeBank');
      this.setRequiredValidators('billNumber');
      this.setRequiredValidators('paymentDate');
      this.setRequiredValidators('paymentTime');
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.financial);
    }
  }

  cardPaymentValidationsForm() {
    try {
      this.setRequiredValidators('accountInformationId');
      //this.setRequiredValidators('typeBank');
      this.setRequiredValidators('billNumber');
      this.setRequiredValidators('paymentDate');
      this.setRequiredValidators('paymentTime');
      this.setRequiredValidators('amount');
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.financial);
    }
  }

  //#endregion

  //#region Api Methods
  onCheckAccessApi() {
    try {
      this.currentService
        .paymentsNewPayment()
        .pipe(this.basePipeOperators())
        .subscribe(
          (res) => {
            if (res) {
              this.pageConfig.isVisibleForm = true;
            }
          },
          (error) => {
            this.pageConfig.isVisibleForm = undefined;
            const timeout = setTimeout(() => {
              this.pageConfig.isVisibleForm = false;
              clearTimeout(timeout);
            }, 10);
          }
        );
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.baseIndexPage
      );
    }
  }

  baseCreateApi(model: CreatePaymentCommand) {
    this.unSubs();
    this.loading = true;
    model.paymentDate = this.paymentDate;
    if (model.typePayment == TypePayments.OnLine) {
      this.createOnlinePaymentApi(model);
    } else if (model.typePayment == TypePayments.Cheque) {
      this.createChequePaymentApi(model);
    } else {
      this.createOtherPaymentsApi(model);
    }
  }

  createOnlinePaymentApi(model) {
    this.currentService
      .paymentsCreatePost({ body: model })
      .pipe(
        takeUntil(this.onDestroy$),
        finalize(() => (this.loading = false))
      )
      .subscribe((result: CustomResult) => {
        if (result.isSucceed) this.descriptorOnlineGatewayApi(result);
        else this.apiNotificationService.notifyMessage({ result });
      });
  }

  createChequePaymentApi(model) {
    try {
      model.chequeAccountNumber = 'IR' + this.chequeAccountNumber;
      this.model.dueDate = DateTimeService.toUTC(this.dueDate);

      model.paymentDate = this.getPaymentDate(model);
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.financial);
    }

    this.currentService
      .paymentsCreatePost({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(
        (result) => {
          try {
            this.apiNotificationService.notifyMessage({ result });
            if (result.isSucceed) {
              this.resetFormAfterPayment();
            }
          } catch (error) {
            this.loggerService.logError(
              this.tagName,
              error,
              EventTypes.financial
            );
          }
        },
        () => (this.loading = false)
      );
  }

  createOtherPaymentsApi(model) {
    model.paymentDate = this.getPaymentDate(model);
    this.currentService
      .paymentsCreatePost({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(
        (result) => {
          this.apiNotificationService.notifyMessage({ result });
          if (result.isSucceed) {
            this.resetFormAfterPayment();
          }
        },
        () => (this.loading = false)
      );
  }

  resetFormAfterPayment() {
    this.formPageConfig.isEditMode = false;
    this.onSuccess();
    this.dynamicTabService.setNewTab('');
    this.dynamicTabService.setNewTab('payments');
    this.dynamicTabService.setActiveTab('payments');
    this.form.reset();
    this.initModel();
    this.changeValidationsForm(TypePayments.OnLine);
  }

  getPaymentDate(model) {
    try {
      let expireDate = new Date(model.paymentDate);
      let dateTime = DateTimeService.addTimeToDate(
        expireDate,
        this.paymentTime
      );
      model.paymentDate = new Date(
        dateTime.getTime() - dateTime.getTimezoneOffset() * 60000
      ).toISOString();
      return model.paymentDate;
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.financial);
    }
  }

  descriptorOnlineGatewayApi(
    result: CustomResultOfGatewayTransporterDescriptor
  ) {
    this.loading = true;

    this.currentService
      .paymentsGetDescriptorOnlineGateway({
        paymentId: Number(result.data),
        typeIpGs: this.selectedBankOnlineGateway.typeIpg,
      })
      .pipe(this.basePipeOperators())
      .subscribe((descriptor: CustomResultOfGatewayTransporterDescriptor) => {
        try {
          if (descriptor.isSucceed) {
            this.openPaymentPage();
            this.form.reset();
          }
          this.gatewayTransporterDescriptorService.checkDescriptor(descriptor);
        } catch (error) {
          this.loggerService.logError(
            this.tagName,
            error,
            EventTypes.financial
          );
        }
      });
  }

  baseUpdateApi(model: CreatePaymentCommand): void {
    this.baseCreateApi(model);
  }

  //#endregion

  //#region file

  getFile(file) {
    try {
      if (!file) {
        this.imageUrl = '';
        this.pdfUrl = '';
        this.model.chequeImageAddress = '';
        this.model.imageName = '';
        return;
      }
      this.onFileChanged(file);
      if (
        this.model.typePayment == TypePayments.Card ||
        this.model.typePayment == TypePayments.DepositToTheAccount
      ) {
        this.unSubs();
        this.currentService
          .paymentsUploadPaymentImage({ body: { Image: file } })
          .pipe(this.basePipeOperators())
          .subscribe((imageName) => {
            this.model.chequeImageAddress = null;
            this.model.imageName = imageName.data;
          });
      }
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.financial);
    }
  }

  onFileChanged(file: any) {
    try {
      if (file && file) {
        this.form.controls['chequeImageAddress'].setErrors(null);

        var reader = new FileReader();
        if (file.type != 'application/pdf')
          reader.onload = (event: any) => {
            this.imageUrl = event.target.result;
            this.pdfUrl = null;
          };
        else if (file.type == 'application/pdf') {
          this.pdfUrl = 'assets/media/svg/files/pdf.svg';
          this.imageUrl = null;
        }
        reader.readAsDataURL(file);
        this.handleFileSelect(file);
      }
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.financial);
    }
  }

  handleFileSelect(evt) {
    try {
      const files = evt;
      const file = files;

      if (files && file) {
        const reader = new FileReader();

        reader.onload = this._handleReaderLoaded.bind(this);

        reader.readAsBinaryString(file);
      }
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.financial);
    }
  }

  _handleReaderLoaded(readerEvt) {
    try {
      const binaryString = readerEvt.target.result;
      let stringImage = btoa(binaryString);
      this.model.chequeImageAddress = stringImage;
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.financial);
    }
  }

  //#endregion

  onSelectPaymentType(type: TypePayments) {
    this.fileUploader()?.clearFile();
    this.model = {};
    this.model.typePayment = type;
    this.imageUrl = null;
    this.pdfUrl = null;
    this.changeValidationsForm(type);
  }

  getSelectedBankOnlineGateway(
    event: GetBankOnlineGatewaysForIncreaseCreditDto
  ) {
    this.model.isOnlineGeneral = event.isOnlineGeneral;
    this.selectedBankOnlineGateway = event;
  }

  numToPersian(number) {
    try {
      this.amountLetters = UtilService.num2persian(number);
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.financial);
    }
  }

  onShowHelpPage() {
    this.isVisibleHelpPage = true;
  }

  onHideHelpPage() {
    this.isVisibleHelpPage = false;
  }

  openPaymentPage() {
    this.dynamicTabService.setNewTab('');
    this.dynamicTabService.setNewTab('payments');
    this.dynamicTabService.setActiveTab('payments');
  }

  closeThisTab() {
    try {
      const TimeOut = setTimeout(() => {
        this.tabsDynamicComponent.manualCloseTab('newPayment');
        clearTimeout(TimeOut);
      }, 50);
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.financial);
    }
  }

  onSubmit() {
    try {
      if (!this.isValidForm(this.form, this.tagName)) return;
      if (this.loading) return;

      if (this.model.typePayment == TypePayments.OnLine)
        this.model.accountInformationId =
          this.selectedBankOnlineGateway.accountInformationId;

      this.baseCreateApi(this.model);
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.financial);
    }
  }
}
